import styles from './Cards.module.scss'

const Cards: React.FC = () => {
  return (
    <section className={styles.pc_cards}>
      <section className={styles.UIUX_card}>
        {/* <img src="/images/img/service/img_service_uiux.jpg" alt="uiuxLP" className={styles.img} /> */}
        <div className={styles.img}></div>
        <div className={styles.text_wrapper}>
          <span className={styles.sub_title}>UX/UIサービス</span>
          <p className={styles.title}>共に考え 共に創る デザインパートナー</p>
          <p className={styles.text}>
            私たちは徹底したデザイン思考でアプリやウェブサイトを利用したビジネスを成功へとつなげます。
          </p>
          <a className={styles.button} href="uiuxdesign-lp2" target="_blank" rel="noopener">
            詳細はこちら
          </a>
        </div>
      </section>
      <section className={styles.picture_card}>
        <div className={styles.pictureWrapper}>
          <img className={styles.imgLeft} src="/images/lp2/gallery_img_1.png" alt="gallery" />
          <img className={styles.imgRight} src="/images/LP/frontend/picture_card.png" alt="gallery" />
        </div>
      </section>
    </section>
  )
}

export default Cards
